// import { initializeApp } from "firebase/app";
// import { getAuth, GoogleAuthProvider,} from "firebase/auth";
// const firebaseConfig = {

//   apiKey: "AIzaSyALwTH2JmWwQoUAABmc--0ElYKTFvIcCS0",
//   authDomain: "dspl-mis-dev.firebaseapp.com",
//   projectId: "dspl-mis-dev",
//   storageBucket: "dspl-mis-dev.appspot.com",
//   messagingSenderId: "875162949862",
//   appId: "1:875162949862:web:aa0694e2ddf11c04424327",
// };

// const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);
// export const provider = new GoogleAuthProvider()




import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
 
};
 // measurementId: process.env.REACT_APP_MEASUREMENT_ID
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);


export { auth, db, storage };